import { Box, Typography } from "@mui/material";
import { useMemo } from "react";
import { uiNeutrals } from "../../../../constants/uiNeutrals";
import { ALL_CATEGORIES } from "../constants";
import {
  allDealCategoryTokenValues,
  isShowingAllDealCategories,
  parseDealCategoryParam,
  serializeDealCategories,
} from "../../../../utils/dealCategoryParam";

const chipSx = (isSelected) => ({
  cursor: "pointer",
  background: "#fff",
  color: "#000",
  borderRadius: "20px",
  px: 2,
  py: 1,
  minHeight: "36px",
  display: "flex",
  alignItems: "center",
  fontSize: "14px",
  fontWeight: 500,
  whiteSpace: "nowrap",
  transition: "all 0.2s ease",
  border: isSelected ? "1px solid #000" : "1px solid #ddd",
  "&:hover": {
    bgcolor: uiNeutrals.surface,
  },
});

export const CategoryFilterSection = ({
  value,
  onChange,
  isMobile = false,
}) => {
  const allTokens = useMemo(() => allDealCategoryTokenValues(), []);
  const rawSelected = useMemo(() => parseDealCategoryParam(value), [value]);

  const allCategoriesMode = useMemo(
    () => isShowingAllDealCategories(value),
    [value],
  );

  const toggleCategory = (catValue) => {
    const base = parseDealCategoryParam(value);
    if (allCategoriesMode) {
      onChange(catValue);
      return;
    }
    const set = new Set(base);
    if (set.has(catValue)) set.delete(catValue);
    else set.add(catValue);
    const next = [...set];
    if (next.length === 0 || next.length === allTokens.length) {
      onChange("");
      return;
    }
    onChange(serializeDealCategories(next));
  };

  return (
    <Box sx={{ py: 1.5 }}>
      <Typography
        variant="subtitle2"
        sx={{
          mb: isMobile ? 1 : 1.25,
          color: "#000",
          fontSize: isMobile ? "16px" : undefined,
          fontWeight: isMobile ? 500 : undefined,
        }}
      >
        Category
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          mb: isMobile ? 0 : 2,
        }}
      >
        <Box
          onClick={() => onChange("")}
          sx={chipSx(allCategoriesMode)}
        >
          All
        </Box>
        {ALL_CATEGORIES.map((cat) => {
          const isSelected = !allCategoriesMode && rawSelected.includes(cat.value);
          return (
            <Box
              key={cat.value}
              onClick={() => toggleCategory(cat.value)}
              sx={chipSx(isSelected)}
            >
              {cat.label}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
